import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthGuard = () => {
    const authSelector = useSelector(state=>state.authReducer);
    /* Check for the token
        - if the token is present then navigate user to the child routes to which he came to using outlet.
        - if user is navigating to the dashboard without a token
            - then navigate user to the login page.
    */
    let auth = { 'token': authSelector.token };
    return (
        auth.token ? <Outlet /> : <Navigate to='login' />
    )
}

export default AuthGuard;